import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import Vuelidate from 'vuelidate';
import VueMask from 'v-mask';
import VueGtag from 'vue-gtag';

import ToastifyMixin from './mixins/ToastifyMixin';
import './config/MomentConfig';
import './config/AppFiltersConfig';
import './config/AppComponentsConfig';
import './config/AppDirectivesConfig';
import './config/BuefyConfig';

Vue.use(VueGtag, {
  config: { id: 'UA-114902838-1' },
});

Vue.config.productionTip = false;

Vue.mixin(ToastifyMixin);
Vue.use(Vuelidate);
Vue.use(VueMask);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
